export default __webpack_public_path__ + "static/media/img-0005.aaf83706.png";